"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankConnection = void 0;
class BankConnection {
}
exports.BankConnection = BankConnection;
